module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "商家ID"
    },
    model: {
      value: (_vm.filters.userId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userId", $$v)
      },
      expression: "filters.userId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getProducts
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.products,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "160px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商品安装指导"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.installGuidance))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "到店安装费用"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.installMoney)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "工程师普通车型补贴"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.commonSubsidy)))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "160px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "荣康万家普通车型差价"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.commonProfit)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "工程师高端车型补贴"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.seniorSubsidy)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "荣康万家高端车型差价"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatMoney")(props.row.seniorProfit)))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "label-width": "160px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.remark))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "技能标签"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.skillsDesc))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productId",
      "label": "商品ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "商家ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productType",
      "label": "商品类型",
      "formatter": _vm.formatProductType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "商品状态",
      "formatter": _vm.formatState
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productLevel",
      "label": "商品级别",
      "formatter": _vm.formatProductLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.rowCount,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "customClass": "customWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品名称",
      "prop": "productName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "productName", $$v)
      },
      expression: "editForm.productName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品类型",
      "prop": "productType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商品类型"
    },
    model: {
      value: (_vm.editForm.productType),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "productType", $$v)
      },
      expression: "editForm.productType"
    }
  }, _vm._l((_vm.productType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品状态",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商品状态"
    },
    model: {
      value: (_vm.editForm.state),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "state", $$v)
      },
      expression: "editForm.state"
    }
  }, _vm._l((_vm.state), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品级别",
      "prop": "productLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商品级别"
    },
    model: {
      value: (_vm.editForm.productLevel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "productLevel", $$v)
      },
      expression: "editForm.productLevel"
    }
  }, _vm._l((_vm.productLevel), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品安装指导",
      "prop": "installGuidance"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.installGuidance),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "installGuidance", $$v)
      },
      expression: "editForm.installGuidance"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "到店安装费用",
      "prop": "installMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.installMoney),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "installMoney", $$v)
      },
      expression: "editForm.installMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师普通车型补贴",
      "prop": "commonSubsidy"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.commonSubsidy),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "commonSubsidy", $$v)
      },
      expression: "editForm.commonSubsidy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "荣康万家普通车型差价",
      "prop": "commonProfit"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.commonProfit),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "commonProfit", $$v)
      },
      expression: "editForm.commonProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师高端车型补贴",
      "prop": "seniorSubsidy"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.seniorSubsidy),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "seniorSubsidy", $$v)
      },
      expression: "editForm.seniorSubsidy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "荣康万家高端车型差价",
      "prop": "seniorProfit"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.seniorProfit),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "seniorProfit", $$v)
      },
      expression: "editForm.seniorProfit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "技能标签",
      "prop": "skills"
    }
  }, [_c('el-transfer', {
    attrs: {
      "props": {
        key: 'no',
        label: 'label'
      },
      "data": _vm.skills
    },
    model: {
      value: (_vm.editForm.skills),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "skills", $$v)
      },
      expression: "editForm.skills"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "remark", $$v)
      },
      expression: "editForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "customClass": "customWidth",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品名称",
      "prop": "productName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "productName", $$v)
      },
      expression: "addForm.productName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "产品类型",
      "prop": "productType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择产品类型"
    },
    model: {
      value: (_vm.addForm.productType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "productType", $$v)
      },
      expression: "addForm.productType"
    }
  }, _vm._l((_vm.productType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品状态",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商品状态"
    },
    model: {
      value: (_vm.addForm.state),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "state", $$v)
      },
      expression: "addForm.state"
    }
  }, _vm._l((_vm.state), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "商品级别",
      "prop": "productLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择商品级别"
    },
    model: {
      value: (_vm.addForm.productLevel),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "productLevel", $$v)
      },
      expression: "addForm.productLevel"
    }
  }, _vm._l((_vm.productLevel), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品安装指导",
      "prop": "installGuidance"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.installGuidance),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "installGuidance", $$v)
      },
      expression: "addForm.installGuidance"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "到店安装费用",
      "prop": "installMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.installMoney),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "installMoney", $$v)
      },
      expression: "addForm.installMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师普通车型补贴",
      "prop": "commonSubsidy"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.commonSubsidy),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "commonSubsidy", $$v)
      },
      expression: "addForm.commonSubsidy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "荣康万家普通车型差价",
      "prop": "commonProfit"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.commonProfit),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "commonProfit", $$v)
      },
      expression: "addForm.commonProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师高端车型补贴",
      "prop": "seniorSubsidy"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.seniorSubsidy),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "seniorSubsidy", $$v)
      },
      expression: "addForm.seniorSubsidy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "荣康万家高端车型差价",
      "prop": "seniorProfit"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.seniorProfit),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "seniorProfit", $$v)
      },
      expression: "addForm.seniorProfit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "技能标签",
      "prop": "skills"
    }
  }, [_c('el-transfer', {
    attrs: {
      "props": {
        key: 'no',
        label: 'label'
      },
      "data": _vm.skills
    },
    model: {
      value: (_vm.addForm.skills),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "skills", $$v)
      },
      expression: "addForm.skills"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "remark", $$v)
      },
      expression: "addForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b77c76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/productList.vue
// module id = 1086
// module chunks = 1